import { z } from 'zod';

export const HistoryTypeSchema = z.enum([
  'PROMOTION',
  'TRANSFER',
  'SALARY_REVISION',
  'DESIGNATION_CHANGE',
  'DEPARTMENT_CHANGE',
  'CONTRACT_RENEWAL',
  'WARNING',
  'APPRECIATION',
]);

export const EmployeeHistoryInputSchema = z.object({
  type: HistoryTypeSchema,
  fromValue: z.unknown().optional(),
  toValue: z.unknown().optional(),
  effectiveDate: z.union([z.string().datetime(), z.string().date()]),
  reason: z.string().max(2000).optional().nullable(),
  documentUrl: z.string().max(500).optional().nullable(),
});
export type EmployeeHistoryInput = z.infer<typeof EmployeeHistoryInputSchema>;
